import { NgModule } from '@angular/core';
import { PTableScrollRestoreDirective } from './p-table-scroll-restore.directive';
@NgModule({
  declarations: [PTableScrollRestoreDirective],
  exports: [PTableScrollRestoreDirective],
})
export class PTableScrollRestoreModule {}
